import { useStore } from 'zustand';
import { useMemo } from 'react';
import { useAppStore } from '../store/main';
import type { SessionStore } from '../store/session/main';
import { useStaticAppStore } from './useStaticAppStore';

export function useStaticSessionStore(sessionId: string) {
  const { sessionStores } = useStaticAppStore();
  return useMemo(() => sessionStores[sessionId]?.getState(), [sessionId, sessionStores]);
}

export function useSessionStore<U>(sessionId: string, selector: (state: SessionStore) => U) {
  const sessionStores = useAppStore((store) => store.sessionStores);
  const store = useStore(sessionStores[sessionId], selector);
  return store;
}
